








































































































































































































































import {
  defineComponent, ref,
  PropType,
  computed,
  watch,
} from '@nuxtjs/composition-api';
import {
  SfSelect, SfInput, SfSelectOption, SfButton,
} from '~/components/StorefrontUi';
import { ValidationProvider, extend } from 'vee-validate';
import { required, min, digits } from 'vee-validate/dist/rules';
// import { validateNip } from '~/helpers/validateNip';
import { useUiNotification } from '~/composables';
import useBilling from '~/modules/checkout/composables/useBilling';
import useShipping from '~/modules/checkout/composables/useShipping';
import { getInitialCheckoutAddressForm } from '~/helpers/checkout/address';
import type { CheckoutAddressForm } from '~/helpers/checkout/address';
import { debounce } from 'lodash-es';
import type { UserType } from '~/modules/checkout/components/ShippingAndPayment/UserType.vue';

extend('required', {
  ...required,
  message: 'This field is required',
});
extend('min', {
  ...min,
  message: 'The field should have at least {length} characters',
});
extend('digits', {
  ...digits,
  message: 'Please provide a valid phone number',
});
// extend('vatid', {
//   message: 'Please provide a valid NIP',
//   validate: validateNip,
// });

export default defineComponent({
  name: 'CompanyBillingAddressForm',
  components: {
    ValidationProvider,
    SfInput,
    SfButton,
    SfSelect,
    SfSelectOption,
  },
  props: {
    billingDetails: {
      type: Object as () => CheckoutAddressForm,
      required: true,
    },
    changeBillingDetails: {
      type: Function as PropType<(data: CheckoutAddressForm) => void>,
      required: true,
    },
    countriesList: {
      type: Array as PropType<{
        id: string;
        label: string;
        englishLabel: string;
        abbreviation: string;
      }[]>,
      required: true,
    },
    subClassName: {
      type: String,
      default: '',
    },
    selectedUserType: {
      type: String as PropType<UserType | null>,
      default: null,
    },
  },
  setup(props) {
    const { loadVatIdData, error: billingError } = useBilling();
    const { load: loadShipping } = useShipping();
    const { send: sendNotification } = useUiNotification();
    const fetchedVatIdData = ref(false);
    const companyBillingAddress = ref<CheckoutAddressForm>(props.billingDetails);

    const changeCompanyBillingAddress = (field: keyof CheckoutAddressForm, value: string) => {
      companyBillingAddress.value[field] = value;
    };

    const changeCountry = (id: string) => {
      changeCompanyBillingAddress('country_code', id);
      changeCompanyBillingAddress('region', '');
    };

    const handleVatIdButtonClick = async () => {
      if (fetchedVatIdData.value) {
        fetchedVatIdData.value = false;
        const initialForm = getInitialCheckoutAddressForm();
        companyBillingAddress.value = {
          ...companyBillingAddress.value,
          ...initialForm,
        };
      } else {
        const vatId = props.billingDetails.vat_id;
        const countryCode = props.billingDetails.country_code;
        const isPolishVat = countryCode === 'PL';
        const response = await loadVatIdData({ vatId, countryCode, isPolishVat });
        if (!response) {
          fetchedVatIdData.value = false;
          sendNotification({
            id: Symbol('load-vat-id-error'),
            message: billingError.value.loadVatIdData.message,
            type: 'danger',
            icon: 'check',
            persist: false,
          });
          return;
        }
        const shippingDetails = await loadShipping();
        companyBillingAddress.value = {
          ...response,
          firstname: shippingDetails?.firstname || '',
          lastname: shippingDetails?.lastname || '',
        };
        fetchedVatIdData.value = true;
      }
    };

    const shouldHideVatIdButton = computed(() => billingError.value?.loadVatIdData?.name === 'by hand');

    watch(
      () => companyBillingAddress.value,
      debounce(() => {
        props.changeBillingDetails(companyBillingAddress.value);
      }, 300),
      { deep: true },
    );

    return {
      fetchedVatIdData,
      changeCountry,
      handleVatIdButtonClick,
      shouldHideVatIdButton,
      changeCompanyBillingAddress,
    };
  },
});
